import { isTargetType } from '#components/patterns/audit-log/type-string-maps.ts';
import type { TargetType } from '#dn-types/audit-log.ts';

export type TimeFrame = '7' | '30' | '90';

export type TargetOption = 'all' | TargetType;

export type FormData = {
  targetType: TargetOption;
  timeFrame: TimeFrame;
  targetId?: string;
};

export const DEFAULT_VALUES = { targetType: 'all', timeFrame: '7' } as const;

export function validateTargetOptionParam(param?: string): TargetOption {
  if (param && (param === 'all' || isTargetType(param))) {
    return param;
  }
  return DEFAULT_VALUES.targetType;
}
